module.exports = __webpack_public_path__ + "img/undraw_no_data_qbuo.cb61ac4f.svg";